export const leadsErrorCodes = {
  pl: {
    '0000': 'Nierozpoznany błąd. Nasz zespół analizuje problem. Przepraszamy',
    AC0000: 'Nierozpoznany błąd. Nasz zespół analizuje problem. Przepraszamy',
    AC0001: 'Brak SSL dla wskazanej domeny',
    AC0002:
      'Błędny klucz API. Należy wprowadzić poprawny klucz API w integracji',
    AC0003:
      'Błędny adres docelowy dla API. Należy wprowadzić poprawny adres docelowy dla API w integracji',
    AC0004:
      'Błędny identyfikator listy kontaktów lub lista nie istnieje. Należy wprowadzić poprawny identyfikator listy lub dodać listę po stronie serwisu',
    AC0005: 'Błędne dane dostarczone z formularza',
    AC0006: 'Nie opłacono konta w serwisie',
    AC0007:
      'Wystąpił błąd krytyczny po stronie serwisu. Zazwyczaj problem jest tymczasowy',
    AC0008: 'Serwis jest tymczasowo niedostępny. Zalecamy ponowienie wysyłki',
    AC0009: 'Serwis jest tymczasowo przeciążony. Zalecamy ponowienie wysyłki',
    AC0010: 'Podany email już istnieje w serwisie',
    AC0011: 'Nie znaleziono tagu',
    AC0012: 'Wystąpił duplikat tagu w kontakcie',
    AC0013: 'Niepoprawny adres email',
    AC0014: 'Nie znaleziono kontaktu w celu powiązania go z listą',
    AC0015: 'Email istnieje w bazie kontaktów',
    AC0016:
      'Niepoprawna wartość tagu dla tego kontaktu. Możliwe, że kontakt już posiada ten tag.',
    AC0017: 'Wystąpił konflikt w danych',
    AC0018:
      'Problem po stronie serwisu. Transfer zamknięty z pozostałymi zaległymi danymi do odczytu',
    AC0019:
      'Serwer ActiveCampaign nic nie zwrócił co jest traktowane jako błąd. (Kod CURL 52)',
    AC0020: 'Subskrybenta nie znaleziono',
    AC0021:
      'ActiveCampaign zwrócił błąd 404. Proszę sprawdź Twoją konfigurację integracji w edytorze',
    AC0022:
      'ActiveCampaign zwrócił błąd 405. Proszę sprawdź Twoją konfigurację integracji w edytorze',
    AW0000: 'Nierozpoznany błąd. Nasz zespół analizuje problem. Przepraszamy',
    AW0001: 'Błędne dane autoryzacyjne do API',
    AW0002: 'Konto zostało tymczasowo zawieszone',
    AW0003: 'Błędne dane dostarczone z formularza',
    AW0004:
      'Wystąpił błąd krytyczny po stronie serwisu. Zazwyczaj problem jest tymczasowy',
    AW0005: 'Serwis jest tymczasowo niedostępny. Zalecane ponowienie wysyłki',
    AW0006: 'Serwis jest tymczasowo przeciążony. Zalecane ponowienie wysyłki',
    AW0007: 'Subskrybent istnieje w serwisie',
    AW0008: 'Adres email jest zablokowany',
    AW0009: 'Niepoprawny adres email',
    AW0010:
      'Serwer AWeber nic nie zwrócił co jest traktowane jako błąd. (Kod CURL 52)',
    AW0011:
      'Nie znaleziono podanej listy. Popraw konfigurację integracji w edytorze',
    CA0000: 'Nierozpoznany błąd. Nasz zespół analizuje problem. Przepraszamy ',
    CA0001:
      'Błędny klucz API. Należy wprowadzić poprawny klucz API w integracji',
    CA0002:
      'Błędny identyfikator listy kontaktów lub lista nie istnieje. Należy wprowadzić poprawny identyfikator listy lub dodać listę po stronie serwisu',
    CA0003: 'Błędne dane dostarczone z formularza',
    CA0004:
      'Wystąpił błąd krytyczny po stronie serwisu. Zazwyczaj problem jest tymczasowy',
    CA0005: 'Serwis jest tymczasowo niedostępny. Zalecane ponowienie wysyłki',
    CA0006: 'Serwis jest tymczasowo przeciążony. Zalecane ponowienie wysyłki',
    CA0007: 'Niepoprawny numer telefonu',
    CM0000: 'Nierozpoznany błąd. Nasz zespół analizuje problem. Przepraszamy ',
    CM0001:
      'Błędny klucz API. Należy wprowadzić poprawny klucz API w integracji',
    CM0002:
      'Błędny identyfikator klienta. Należy wprowadzić poprawny identyfikator klienta dla API w integracji',
    CM0003:
      'Błędny identyfikator listy kontaktów lub lista nie istnieje. Należy wprowadzić poprawny identyfikator listy lub dodać listę po stronie serwisu',
    CM0004: 'Błędne dane dostarczone z formularza',
    CM0005:
      'Wystąpił błąd krytyczny po stronie serwisu. Zazwyczaj problem jest tymczasowy',
    CM0006: 'Serwis jest tymczasowo niedostępny. Zalecane ponowienie wysyłki',
    CM0007: 'Serwis jest tymczasowo przeciążony. Zalecane ponowienie wysyłki',
    CM0008: 'Adres Email już istnieje na niepotwierdzonej liście.',
    CM0009: 'Adres Email już istnieje na liście.',
    CM0010: 'Adres Email już istnieje na liście bez subskrypcji.',
    CK0000: 'Nierozpoznany błąd. Nasz zespół analizuje problem. Przepraszamy',
    CK0001: 'Błędne dane autoryzacyjne do API',
    CK0002: 'Błędne dane dostarczone z formularza',
    CK0003:
      'Wystąpił błąd krytyczny po stronie serwisu. Zazwyczaj problem jest tymczasowy',
    CK0004: 'Serwis jest tymczasowo niedostępny. Zalecane ponowienie wysyłki',
    CK0005: 'Serwis jest tymczasowo przeciążony. Zalecane ponowienie wysyłki',
    CK0006: 'Niepoprawny adres email',
    CK0007:
      'Niepoprawna konfuguracja integracji w edytorze. Spróbuj skonfigurować integracje ponownie.',
    CK0008: 'Niepoprawna wartość parametru first name',
    CK0009: 'Niepoprawna wartość parametru first email',
    FM0000: 'Nierozpoznany błąd. Nasz zespół analizuje problem. Przepraszamy',
    FM0001: 'Błędne dane autoryzacyjne do API',
    FM0002: 'Błędne dane dostarczone z formularza',
    FM0003:
      'Wystąpił błąd krytyczny po stronie serwisu. Zazwyczaj problem jest tymczasowy',
    FM0004: 'Serwis jest tymczasowo niedostępny. Zalecane ponowienie wysyłki',
    FM0005: 'Serwis jest tymczasowo przeciążony. Zalecane ponowienie wysyłki',
    FM0006:
      'Błędny identyfikator listy kontaktów lub lista nie istnieje. Należy wprowadzić poprawny identyfikator listy lub dodać listę po stronie serwisu',
    FM0007: 'Błędny adres email',
    FM0008: 'Problem z połączeniem SSL',
    FM0009: 'Niepoprawna wartość pola formularza lub pole nie istnieje',
    GR0000: 'Nierozpoznany błąd. Nasz zespół analizuje problem. Przepraszamy',
    GR0001: 'Błędne dane autoryzacyjne dla API',
    GR0002: 'Błędny format pola niestandardowego',
    GR0003: 'Błędne dane dostarczone z formularza',
    GR0004:
      'Wystąpił błąd krytyczny po stronie serwisu. Zazwyczaj problem jest tymczasowy',
    GR0005: 'Serwis jest tymczasowo niedostępny. Zalecane ponowienie wysyłki',
    GR0006: 'Serwis jest tymczasowo przeciążony. Zalecane ponowienie wysyłki',
    GR0007: 'Podany email już istnieje w serwisie',
    GR0008: 'Podany email widnieje na czarnej liście w serwisie',
    GR0009: 'Podany email był już wcześniej usunięty z serwisu',
    GR0010: 'Niepoprawny adres email',
    GR0011: 'Podana błędna kampania lub kampania nie istnieje',
    GR0012: 'Kontakt oczekuje na dodanie po stronie serwisu',
    GR0013: 'Kontakt był już wcześniej odrzucony w serwisie GetResponse',
    GR0014:
      'Niepoprawny klucz API. Zaleca się ponowną konfigurację integracji.',
    GR0015: 'Niepoprawny endpoint. Zaleca się ponowną konfigurację integracji.',
    GR0016: 'Niepoprawna domena. Zaleca się ponowną konfigurację integracji.',
    GR0017: 'Nie można dodać kontaktu, który jest zablokowany.',
    GS0000: 'Nierozpoznany błąd. Nasz zespół analizuje problem. Przepraszamy',
    GS0001:
      'Wystąpił błąd krytyczny po stronie serwisu. Zazwyczaj problem jest tymczasowy',
    GS0002: 'Serwis jest tymczasowo niedostępny. Zalecane ponowienie wysyłki',
    GS0003: 'Serwis jest tymczasowo przeciążony. Zalecane ponowienie wysyłki',
    GS0004:
      'Nieprawidłowa autoryzacja. Spróbuj skonfigurować integrację ponownie.',
    GS0005:
      'Nieprawidłowa konfiguracja. Spróbuj skonfigurować integrację ponownie.',
    GS0006:
      'Przekroczona zakres arkusza. Zwiększ ilość wierszy w podpiętym arkuszu',
    GS0007: 'Nieprawidłowa nazwa arkusza. Nie używaj znaków specjalnych',
    GS0008: 'Konto zbanowane z integracji GS',
    GS0009: 'Nieprawidłowy access token. Sprawdź konfigurację w edytorze',
    HS0000: 'Nierozpoznany błąd. Nasz zespół analizuje problem. Przepraszamy',
    HS0001:
      'Błędny klucz API. Należy wprowadzić poprawny klucz API w integracji',
    HS0002: 'Konto zostało tymczasowo zawieszone',
    HS0003: 'Błędne dane dostarczone z formularza',
    HS0004:
      'Wystąpił błąd krytyczny po stronie serwisu. Zazwyczaj problem jest tymczasowy',
    HS0005: 'Serwis jest tymczasowo niedostępny. Zalecane ponowienie wysyłki',
    HS0006: 'Serwis jest tymczasowo przeciążony. Zalecane ponowienie wysyłki',
    HS0007: 'Niepoprawny adres email',
    HS0008: 'Niepoprawna wartość dla pola typu numerycznego w HubSpot',
    HS0009:
      'Ta integracja nie jest już aktywna. Udostępniliśmy ulepszoną integrację HubSpot OAuth. Jeśli nadal chcesz przesyłać leady do swojego konta w HubSpot, skonfiguruj nową integrację.',
    LB0000: 'Nierozpoznany błąd. Nasz zespół analizuje problem. Przepraszamy ',
    LB0001:
      'Błędny klucz API. Należy wprowadzić poprawny klucz API w integracji',
    LB0002: 'Błędne dane dostarczone z formularza',
    LB0003:
      'Wystąpił błąd krytyczny po stronie serwisu. Zazwyczaj problem jest tymczasowy',
    LB0004: 'Serwis jest tymczasowo niedostępny. Zalecane ponowienie wysyłki',
    LB0005: 'Serwis jest tymczasowo przeciążony. Zalecane ponowienie wysyłki',
    LB0006: 'Kampania nie istnieje',
    LB0007: 'Brak SSL dla wskazanej domeny',
    LB0008: 'Certyfikat SSL dla domeny stracił swoją ważność',
    MC0000: 'Nierozpoznany błąd. Nasz zespół analizuje problem. Przepraszamy',
    MC0001: 'Błędne dane autoryzacyjne dla API',
    MC0002: 'Konto jest nie aktywne',
    MC0003: 'Błędne dane dostarczone z formularza',
    MC0004:
      'Wystąpił błąd krytyczny po stronie serwisu. Zazwyczaj problem jest tymczasowy',
    MC0005: 'Serwis jest tymczasowo niedostępny. Zalecane ponowienie wysyłki',
    MC0006: 'Serwis jest tymczasowo przeciążony. Zalecane ponowienie wysyłki',
    MC0007: 'Niepoprawny identyfikator zainteresowania',
    MC0008:
      'Klucz API jest nie aktywny. Należy wygenerować nowy klucz API w serwisie, a następnie wprowadzić go w integracji',
    MC0009: 'Niepoprawny adres email',
    MC0010: 'Niepoprawne ustawienia pól dodatkowych',
    MC0011: 'Kontakt istnieje',
    MC0012:
      'Kontakt został dodany do wielu list. Serwis nie pozwala na dalsze dopisywanie kontaktu do innych list',
    MC0013:
      'Nie znaleziono zasobu. Prawdopodobnie zostały podane błędne dane konfiguracyjne',
    MC0014: 'Niepoprawny identyfikator listy',
    MC0015: 'Email został usunięty i nie może zostać dodany ponownie',
    MC0016: 'Niepoprawny klucz API',
    MC0017: 'Niepoprawny status',
    MC0018: "Sign '-' not found in API KEY. Fix API KEY in editor",
    MC0019: 'Przekazano nieprawidłowy typ niestandardowego pola',
    ML0000: 'Nierozpoznany błąd. Nasz zespół analizuje problem. Przepraszamy',
    ML0001:
      'Błędny klucz API. Należy wprowadzić poprawny klucz API w integracji',
    ML0002: 'Błędne dane dostarczone z formularza',
    ML0003:
      'Wystąpił błąd krytyczny po stronie serwisu. Zazwyczaj problem jest tymczasowy',
    ML0004: 'Serwis jest tymczasowo niedostępny. Zalecane ponowienie wysyłki',
    ML0005: 'Serwis jest tymczasowo przeciążony. Zalecane ponowienie wysyłki',
    ML0006: 'Niepoprawny adres email',
    ML0007: 'Osoba o podanym adresie email wypisała się z listy',
    ML0008: 'Typ subskrybenta jest odrzucany',
    ML0009: 'Osoba o podanym adresie email nie potwierdziła swojego maila',
    ML0010: 'Osoba o podanym adresie email została wykryta jako spamer',
    ML0011: 'Niepoprawny klucz API. Zaleca się ponowną konfigurację integracji',
    ML0012: 'Osoba o podanym adresie email jest tymczasowo zablokowana',
    ML0013:
      'Niepoprawna konfuguracja integracji w edytorze. Spróbuj skonfigurować integracje ponownie.',
    ML0014:
      'Dane z formularza zbyt duże. Miller Lite API zwrócił kod odpowiedzi 413.',
    SA0000: 'Nierozpoznany błąd. Nasz zespół analizuje problem. Przepraszamy ',
    SA0001: 'Błędny klucz API lub User Id. Należy poprawić dane autoryzacyjne',
    SA0002:
      'Błędny identyfikator listy lub lista nie istnieje. Należy wprowadzić poprawny identyfikator listy lub dodać listę po stronie serwisu',
    SA0003: 'Błędny adres email lub adres email nie istnieje.',
    SA0004:
      'Wystąpił błąd krytyczny po stronie serwisu. Zazwyczaj problem jest tymczasowy',
    SA0005: 'Serwis jest tymczasowo niedostępny. Zalecane ponowienie wysyłki',
    SF0000: 'Nierozpoznany błąd. Nasz zespół analizuje problem. Przepraszamy ',
    SF0001:
      'Błędne dane autoryzacyjne. Należy wprowadzić poprawne dane autoryzacyjne w integracji',
    SF0002: 'Błędne dane dostarczone z formularza',
    SF0003:
      'Wystąpił błąd krytyczny po stronie serwisu. Zazwyczaj problem jest tymczasowy',
    SF0004: 'Kontakt już istnieje w serwisie',
    SF0005:
      'Błąd walidacji danych. Proszę o weryfikację ustawień walidacji po stronie serwisu',
    SF0006: 'Wygasło hasło do konta API',
    SF0007: 'Jest powiązanie do pola, które nie istnieje ',
    SF0008: 'Kontakt nie jest unikalny',
    SF0009: 'Wartość dla jednego z pól formularza jest zbyt długa',
    SF0010:
      'Jedno z pól nie istnieje lub nie może być zapisane. Sprawdź to pole w Salesforce',
    SF0011: 'Niepoprawny adres e-mail',
    SF0012: 'Niepoprawny RecordTypeId dla dannego użytkownika',
    SF0013:
      'Nie znaleziono wymaganej kolumny RecordTypeId w encji Leads. Sprawdź konfigurację w salesforce',
    PT0000: 'Nierozpoznany błąd. Nasz zespół analizuje problem. Przepraszamy',
    PT0001: 'Bad request (Kod HTTP 400)',
    PT0002: 'Unprocessable Entity (Kod HTTP 422)',
    PT0003: 'Unauthorized (Kod HTTP 401)',
    PT0004: 'Forbidden (Kod HTTP 403)',
    PT0005: 'Not Found (Kod HTTP 404)',
    PT0006: 'Gone (Kod HTTP 410)',
    PT0007: 'Method not allowed (Kod HTTP 405)',
    PT0008: 'Unsupported media type (Kod HTTP 415)',
    PT0009: 'Conflict (Kod HTTP 409)',
    PT0010: 'Internal server error (Kod HTTP 500)',
    PT0011: 'Too many request (Kod HTTP 429)',
    PT0012: 'Request timeout (Kod HTTP 408)',
    PT0013: 'Service unavaliable (Kod HTTP 503)',
    PT0014: 'Bad gateway (Kod HTTP 502)',
    PT0015: 'Gateway timeout (Kod HTTP 504)',
    PT0016: 'Cloudflare origin timeout or down (Kod HTTP 521)',
    PT0017:
      "Couldn't resolve host. The given remote host was not resolved (Kod CURL 6) ",
    PT0018: 'Failed to connect to host or proxy (Kod CURL 7)',
    PT0019:
      'Operation timeout. The specified time-out period was reached according to the conditions (Kod CURL 28)',
    PT0020:
      'A problem occurred somewhere in the SSL/TLS handshake (Kod CURL 35)',
    PT0021:
      'Nothing was returned from the server, getting nothing is considered an error (Kod CURL 52)',
    PT0022: 'OpenSSL SSL_read : SSL_ERROR_SYSCALL (Kod CURL 56)',
    PT0023:
      "CURLE_PEER_FAILED_VERIFICATION : The remote server's SSL certificate or SSH md5 fingerprint was deemed not OK (Kod CURL 60)",
    PT0024: 'Podano błędny adres URL',
    PT0025: '530 Not logged in (or Password Rejected)',
    PT0026: 'Origin Unreachable (Kod HTTP 523)',
    PT0027: 'Origin SSL Handshake Error (Kod HTTP 525)',
    PT0028: 'Wymagana płatność (Kod HTTP 402)',
    PT0029: 'Przekierowanie URL (Kod HTTP 302)',
    PT0030: 'Error while processing content unencoding (Kod CURL 61)',
    PT0031: "I'm a teapot (Kod HTTP 418)",
    PT0032:
      'Transfer closed with outstanding read data remaining (CURL code 18)',
    PT0033: '508 Loop Detected',
    WH0000: 'Nierozpoznany błąd. Nasz zespół analizuje problem. Przepraszamy',
    WH0001: 'Bad request (Kod HTTP 400)',
    WH0002: 'Unprocessable Entity (Kod HTTP 422)',
    WH0003: 'Unauthorized (Kod HTTP 401)',
    WH0004: 'Forbidden (Kod HTTP 403)',
    WH0005: 'Not Found (Kod HTTP 404)',
    WH0006: 'Gone (Kod HTTP 410)',
    WH0007: 'Method not allowed (Kod HTTP 405)',
    WH0008: 'Unsupported media type (Kod HTTP 415)',
    WH0009: 'Conflict (Kod HTTP 409)',
    WH0010: 'Internal server error (Kod HTTP 500)',
    WH0011: 'Too many request (Kod HTTP 429)',
    WH0012: 'Request timeout (Kod HTTP 408)',
    WH0013: 'Service unavaliable (Kod HTTP 503)',
    WH0014: 'Bad gateway (Kod HTTP 502)',
    WH0015: 'Gateway timeout (Kod HTTP 504)',
    WH0016: 'Cloudflare origin timeout or down (Kod HTTP 521)',
    WH0017: 'Wymagana płatność (Kod HTTP 402)',
    WH0018:
      'Podano błędny adres URL. Popraw konfigurację integracji w edytorze.',
    WH0019: 'Przekierowanie URL (Kod HTTP 302)',
    WH0020: 'Loop Detected (Kod HTTP 508)',
    WH0021: 'Insufficient Storage (Kod HTTP 507)',
    WH0022: 'Not Acceptable (Kod HTTP 406)',
    ZH0001: 'Błędne dane autoryzacyjne dla API',
    ZH0002: 'Użytkownik posiada nie aktywne konto',
    ZH0003: 'Błędne dane dostarczone z formularza',
    ZH0004:
      'Wystąpił błąd krytyczny po stronie serwisu. Zazwyczaj problem jest tymczasowy',
    ZH0005: 'Serwis jest tymczasowo niedostępny. Zalecane ponowienie wysyłki',
    ZH0006: 'Serwis jest tymczasowo przeciążony. Zalecane ponowienie wysyłki',
    ZH0007: 'Brak dostępu',
    ZH0008: 'Niepoprawny token dostępu do API',
    ZH0009:
      'Brak pola obowiązkowego. Powinieneś poprawić konfigurację formularza.',
    ZH0010: 'Błędny URL',
    ZH0011:
      'Nowy rekord nie może zostać utworzony ponieważ maksymalny limit danych został osiągnięty.',
    PD0001:
      'Błędne dane autoryzacyjne. Należy wprowadzić poprawne dane autoryzacyjne w integracji',
    PD0002: 'Niepoprawny adres email',
    PD0003:
      'Wystąpił błąd krytyczny po stronie serwisu. Zazwyczaj problem jest tymczasowy',
    PD0004: 'Serwis jest tymczasowo niedostępny. Zalecane ponowienie wysyłki',
    PD0005: 'Serwis jest tymczasowo przeciążony. Zalecane ponowienie wysyłki',
    PD0006: 'Zasobu nie znaleziono',
    PD0007:
      'Niepoprawny identyfikator kampani. Zaleca się ponowną konfigurację integracji.',
    PD0008:
      'Niepoprawny klucz API. Zaleca się ponowną konfigurację integracji.',
    PD0009: 'Nie znaleziono "stage" lub zostało usunięte',
    PD0010: 'Nieokreślony błąd w dostarczonych danych',
    LS0001:
      'Błędny klucz API. Należy wprowadzić poprawny klucz API w integracji',
    LS0002: 'Błędne dane dostarczone z formularza',
    LS0003:
      'Wystąpił błąd krytyczny po stronie serwisu. Zazwyczaj problem jest tymczasowy',
    LS0004: 'Serwis jest tymczasowo niedostępny. Zalecane ponowienie wysyłki',
    LS0005: 'Serwis jest tymczasowo przeciążony. Zalecane ponowienie wysyłki',
    LS0006: 'Niepoprawny adres email',
    LS0007:
      'Niepoprawna konfuguracja integracji w edytorze. Spróbuj skonfigurować integracje ponownie.',
    LS0008:
      'Jedno z pól nie zostało wypełnione, ustaw go jako wymagane w ustawieniach formularza',
    LS0009:
      'Kontakt istnieje, ale ma pusty email. Brak możliwości aktualizacji kontaktu.',
    DR0000: 'Nierozpoznany błąd. Nasz zespół analizuje problem. Przepraszamy ',
    DR0001: 'Błędne dane autoryzacyjne do API ',
    DR0002: 'Błędne dane dostarczone z formularza',
    DR0003:
      'Wystąpił błąd krytyczny po stronie serwisu. Zazwyczaj problem jest tymczasowy',
    DR0004: 'Serwis jest tymczasowo niedostępny. Zalecane ponowienie wysyłki',
    DR0005: 'Serwis jest tymczasowo przeciążony. Zalecane ponowienie wysyłki',
    DR0007:
      'Niepoprawna konfuguracja integracji w edytorze. Spróbuj skonfigurować integracje ponownie.',
    DR0008: 'Liczba jest poza zakresem.',
    DR0009: 'Atrybut jest wymagany.',
    DR0010: 'Nazwa atrybutu jest za długa.',
    DR0011: 'Atrybut musi być unikalny.',
    DR0012: 'Niepoprawny adres e-mail.',
    DR0013: 'Niepoprawny adres URL.',
    DR0014: 'Atrubyt musi posiadać prawidłową nazwę domeny.',
    DR0015: 'Atrybut musi mieć prawidłową datę w formacie ISO-8601.',
    DR0016:
      'Atrybut musi posiadać prawidłową listę adresów e-mail oddzielonych przecinkami.',
    DR0017: 'Atrybut musi posiadać prawidłową maskę dni tygodnia.',
    DR0018: 'Zasób został zablokowany lub skasowany.',
    DR0019: 'Identyfikator zasobu jest niepoprawny.',
    ZP0000: 'Nierozpoznany błąd. Nasz zespół analizuje problem. Przepraszamy ',
    ZP0001:
      'Nieprawidłowa konfiguracja. Spróbuj skonfigurować integrację ponownie.',
    ZP0002:
      'Nieprawidłowa konfiguracja Zapa. Przejdź do konfiguracji Zapa i upewnij się, że wszystkie niezbędne pola istnieją.',
    ZP0003: 'Chwilowy błąd po stronie Zapier-a. Spróbuj wysłać lead ponownie.',
    ZO0001:
      'Niepoprawny adres URL Zapier. Popraw konfigurację integracji w edytorze',
    NE0000: 'Nierozpoznany błąd. Nasz zespół analizuje problem. Przepraszamy',
    NE0001: 'Niepoprawny numer telefonu',
    NE0002:
      'Wystąpił błąd krytyczny po stronie serwisu. Zazwyczaj problem jest tymczasowy',
    NE0003: 'Serwis jest tymczasowo niedostępny. Zalecane ponowienie wysyłki',
    NE0004: 'Serwis jest tymczasowo przeciążony. Zalecane ponowienie wysyłki',
    NE0005: 'Niepoprawny security key',
    YL0000: 'Nierozpoznany błąd. Nasz zespół analizuje problem. Przepraszamy',
    YL0001:
      'Wystąpił błąd krytyczny po stronie serwisu. Zazwyczaj problem jest tymczasowy',
    YL0002: 'Serwis jest tymczasowo niedostępny. Zalecane ponowienie wysyłki',
    YL0003: 'Serwis jest tymczasowo przeciążony. Zalecane ponowienie wysyłki',
    ZM0000: 'Nierozpoznany błąd. Nasz zespół analizuje problem. Przepraszamy',
    ZM0001:
      'Wystąpił błąd krytyczny po stronie serwisu. Zazwyczaj problem jest tymczasowy',
    ZM0002: 'Serwis jest tymczasowo niedostępny. Zalecane ponowienie wysyłki',
    ZM0003: 'Serwis jest tymczasowo przeciążony. Zalecane ponowienie wysyłki',
    ZM0004:
      'Wybrany webinar jest już zakończony. Nie można zapisać uczestnika na zakończony webinar',
    ZM0005:
      'Token nie został znaleziony. Czy odinstalowałeś aplikację Landingi w Zoom-ie?',
    ZM0006: 'Rejestracja na ten webinar nie została włączona w serwisie Zoom.',
    ZM0007: 'Przekroczyłeś dzienny limit dodania tego uczestnika na webinar',
    ZM0008: 'Pole "Email" nie może być puste',
    ZM0009: 'Pole "Imię" jest puste, pole powinno być wymagane',
    ZM0010: 'Pole "Nazwisko" jest puste, pole powinno być wymagane',
    ZS0000: 'Nierozpoznany błąd. Nasz zespół analizuje problem. Przepraszamy',
    ZS0001:
      'Wystąpił błąd krytyczny po stronie serwisu. Zazwyczaj problem jest tymczasowy',
    ZS0002: 'Serwis jest tymczasowo niedostępny. Zalecane ponowienie wysyłki',
    ZS0003: 'Serwis jest tymczasowo przeciążony. Zalecane ponowienie wysyłki',
    ZS0004: 'Błędne dane dostarczone z formularza',
    ZS0005:
      'Niepoprawny token autoryzacyjny. Popraw konfigurację integracji w edytorze',
    LW0000: 'Nierozpoznany błąd. Nasz zespół analizuje problem. Przepraszamy',
    LW0001:
      'Wystąpił błąd krytyczny po stronie serwisu. Zazwyczaj problem jest tymczasowy',
    LW0002: 'Serwis jest tymczasowo niedostępny. Zalecane ponowienie wysyłki',
    LW0003: 'Serwis jest tymczasowo przeciążony. Zalecane ponowienie wysyłki',
    LW0004: 'Błędne dane dostarczone z formularza',
    LW0005: 'Webinar nie został znaleziony',
    LW0006:
      'Token został przeterminowany i usunięty. Spróbuj ponownie zalogować się w edytorze',
    HS2000: 'Nierozpoznany błąd. Nasz zespół analizuje problem. Przepraszamy',
    HS2001:
      'Niepoprawny token autoryzacyjny. Popraw konfigurację integracji w edytorze',
    HS2002: 'Konto zostało tymczasowo zawieszone',
    HS2003: 'Błędne dane dostarczone z formularza',
    HS2004:
      'Wystąpił błąd krytyczny po stronie serwisu. Zazwyczaj problem jest tymczasowy',
    HS2005: 'Serwis jest tymczasowo niedostępny. Zalecane ponowienie wysyłki',
    HS2006: 'Serwis jest tymczasowo przeciążony. Zalecane ponowienie wysyłki',
    HS2007: 'Niepoprawny adres email',
    HS2008: 'Niepoprawna wartość dla pola typu numerycznego w HubSpot',
    CR0000: 'Nierozpoznany błąd. Nasz zespół analizuje problem. Przepraszamy',
    CR0001:
      'Wystąpił błąd krytyczny po stronie serwisu. Zazwyczaj problem jest tymczasowy',
    CR0002: 'Serwis jest tymczasowo niedostępny. Zalecane ponowienie wysyłki',
    CR0003: 'Serwis jest tymczasowo przeciążony. Zalecane ponowienie wysyłki',
    CR0004:
      'Creatio zwrócił błąd 400. Proszę sprawdź Twoją konfigurację integracji w edytorze',
    CR0005: 'Brakuję wartość formularza dla podanego formatu daty',
    TC0000: 'Nierozpoznany błąd. Nasz zespół analizuje problem. Przepraszamy',
    TC0001:
      'Wystąpił błąd krytyczny po stronie serwisu. Zazwyczaj problem jest tymczasowy',
    TC0002: 'Serwis jest tymczasowo niedostępny. Zalecane ponowienie wysyłki',
    TC0003: 'Serwis jest tymczasowo przeciążony. Zalecane ponowienie wysyłki',
    TC0004: 'Thrive Coach zwraca 404 (Not Found)',
    TC0005:
      'Nie znaleziono ApiToken. Spróbuj skonfigurować integrację ponownie.',
    TC0006:
      'Nie znaleziono lokalizacji. Spróbuj skonfigurować integrację ponownie.'
  },
  en: {
    '0000': 'Unrecognized error. Our team is analyzing the problem. Sorry',
    AC0000: 'Unrecognized error. Our team is analyzing the problem. Sorry',
    AC0001: 'No SSL for the indicated domain',
    AC0002:
      'Invalid API key. You must enter the correct API key in the integration',
    AC0003:
      'Invalid API destination address. You must enter the correct destination address for the API in the integration',
    AC0004:
      'Invalid contact list ID or list does not exist. You must enter the correct list ID or add a list on the service side',
    AC0005: 'Incorrect data provided from the form',
    AC0006: 'Account is not paid in the service',
    AC0007:
      'A critical error has occurred on the service side. Usually the problem is temporary',
    AC0008: 'The site is temporarily unavailable. Try to send lead again',
    AC0009: 'The site is temporarily unavailable. Try to send lead again',
    AC0010: 'The e-mail address already exists in the service',
    AC0011: 'Tag not found',
    AC0012: 'There was a duplicate tag in contact',
    AC0013: 'Incorrect e-mail address',
    AC0014: 'No contact found to associate with the list',
    AC0015: 'The e-mail address already exists in the service',
    AC0016:
      'Invalid value for contact tag. Maybe the contact already has this tag',
    AC0017: 'Conflict in data',
    AC0018:
      'Server error. Transfer closed with outstanding read data remaining',
    AC0019:
      'Nothing was returned from the server, getting nothing is considered an error (CURL code 52)',
    AC0020: 'Subscriber not found',
    AC0021:
      'ActiveCampaign return error 404 (Not Found) with an empty message. Please check the integration configuration in the editor',
    AC0022:
      'ActiveCampaign return error 405 with an empty message. Please check the integration configuration in the editor',
    AW0000: 'Unrecognized error. Our team is analyzing the problem. Sorry',
    AW0001: 'Incorrect API authorization data',
    AW0002: 'The account has been temporarily suspended',
    AW0003: 'Incorrect data provided from the form',
    AW0004:
      'A critical error has occurred on the service side. Usually the problem is temporary',
    AW0005: 'The site is temporarily unavailable. Try to send lead again',
    AW0006: 'The site is temporarily unavailable. Try to send lead again',
    AW0007: 'The subscriber exists on the website',
    AW0008: 'E-mail address is blocked',
    AW0009: 'Incorrect e-mail address',
    AW0010:
      'Nothing was returned from the server, getting nothing is considered an error (CURL code 52)',
    AW0011:
      'The email list not found. Please fix integration configuration in the editor',
    CA0000: 'Unrecognized error. Our team is analyzing the problem. Sorry',
    CA0001:
      'Invalid API key. You must enter the correct API key in the integration',
    CA0002:
      'Invalid contact list id or list does not exist. You must enter the correct list ID or add a list on the service side',
    CA0003: 'Incorrect data provided from the form',
    CA0004:
      'A critical error has occurred on the service side. Usually the problem is temporary.',
    CA0005: 'The site is temporarily unavailable. Try to send lead again',
    CA0006: 'The site is temporarily unavailable. Try to send lead again',
    CA0007: 'Invalid phone number',
    CM0000: 'Unrecognized error. Our team is analyzing the problem. Sorry',
    CM0001:
      'Invalid API key. You must enter the correct API key in the integration',
    CM0002:
      'Invalid customer ID. You must enter the correct customer ID for API in the integration',
    CM0003:
      'Invalid contact list id or list does not exist. You must enter the correct list ID or add a list on the service side',
    CM0004: 'Incorrect data provided from the form',
    CM0005:
      'A critical error has occurred on the service side. Usually the problem is temporary.',
    CM0006: 'The site is temporarily unavailable. Try to send lead again',
    CM0007: 'The site is temporarily unavailable. Try to send lead again',
    CM0008: 'Email Address exists in unconfirmed list',
    CM0009: 'Email Address exists in suppression list',
    CM0010: 'Email Address exists in unsubscribed list',
    CK0000: 'Unrecognized error. Our team is analyzing the problem. Sorry',
    CK0001: 'Incorrect API authorization data',
    CK0002: 'Incorrect data provided from the form',
    CK0003:
      'A critical error has occurred on the service side. Usually the problem is temporary',
    CK0004: 'The site is temporarily unavailable. Try to send lead again',
    CK0005: 'The site is temporarily unavailable. Try to send lead again',
    CK0006: 'Incorrect e-mail address',
    CK0007:
      'Incorrect integration configuration in editor. Please try configure integration once again.',
    CK0008: 'First name is invalid',
    CK0009: 'Email is invalid',
    FM0000: 'Unrecognized error. Our team is analyzing the problem. Sorry',
    FM0001: 'Incorrect API authorization data',
    FM0002: 'Incorrect data provided from the form',
    FM0003:
      'A critical error has occurred on the service side. Usually the problem is temporary',
    FM0004: 'The service is temporarily unavailable. Try to send lead again',
    FM0005: 'The service is temporarily unavailable. Try to send lead again',
    FM0006:
      'Invalid contact list ID or list does not exist. You must enter the correct list ID or add a list on the service side',
    FM0007: 'Invalid e-mail address',
    FM0008: 'SSL connection problem',
    FM0009: 'Invalid custom field value or field does not exist',
    GR0000: 'Unrecognized error. Our team is analyzing the problem. Sorry',
    GR0001: 'Incorrect authorization data for the API',
    GR0002: 'Invalid custom field format',
    GR0003: 'Incorrect data provided from the form',
    GR0004:
      'A critical error has occurred on the service side. Usually the problem is temporary',
    GR0005: 'The service is temporarily unavailable. Try to send lead again',
    GR0006: 'The service is temporarily unavailable. Try to send lead again',
    GR0007: 'The e-mail address already exists in the service',
    GR0008: 'The e-mail provided is blacklisted in the service',
    GR0009: 'The e-mail provided has already been removed from the service',
    GR0010: 'Incorrect e-mail address',
    GR0011: 'The wrong campaign or campaign specified does not exist',
    GR0012: 'Contact is waiting to be added on the service side',
    GR0013: 'Contact was previously bounced',
    GR0014: 'Invalid API key. Try to configurate integration once again',
    GR0015: 'Invalid endpoint. Try to configurate integration once again',
    GR0016:
      'Provided domain not found. Try to configurate integration once again',
    GR0017: 'Cannot add contact that is blocked',
    GS0000: 'Unrecognized error. Our team is analyzing the problem. Sorry',
    GS0001:
      'A critical error has occurred on the service side. Usually the problem is temporary',
    GS0002: 'The service is temporarily unavailable. Try to send lead again',
    GS0003: 'The service is temporarily unavailable. Try to send lead again',
    GS0004: 'Invalid authorization. Try to configure integration once again',
    GS0005: 'Invalid configuration. Try to configure integration once again',
    GS0006:
      'Sheet range exceeded. Increase the number of rows in the linked sheet',
    GS0007: 'Sheet name is incorrect. Do not use special chars',
    GS0008: 'The account was banned by GS integration',
    GS0009: 'Invalid access token. Check the configuration in the editor',
    HS0000: 'Unrecognized error. Our team is analyzing the problem. Sorry',
    HS0001:
      'Invalid API key. You must enter the correct API key in integration',
    HS0002: 'The account has been temporarily suspended',
    HS0003: 'Incorrect data provided from the form',
    HS0004:
      'A critical error has occurred on the service side. Usually the problem is temporary',
    HS0005: 'The service is temporarily unavailable. Try to send lead again',
    HS0006: 'The service is temporarily unavailable. Try to send lead again',
    HS0007: 'Incorrect e-mail address',
    HS0008: 'Invalid value for a numeric type field in HubSpot',
    HS0009:
      'This integration is no longer active. We’ve launched an updated HubSpot OAuth integration. If you want to send the leads to your HubSpot account, please set up the new integration.',
    LB0000: 'Unrecognized error. Our team is analyzing the problem. Sorry',
    LB0001:
      'Invalid API key. You must enter the correct API key in the integration',
    LB0002: 'Incorrect data provided from the form',
    LB0003:
      'A critical error has occurred on the service side. Usually the problem is temporary',
    LB0004: 'The service is temporarily unavailable. Try to send lead again',
    LB0005: 'The service is temporarily unavailable. Try to send lead again',
    LB0006: 'The campaign does not exist',
    LB0007: 'No SSL for the indicated domain',
    LB0008: "The domain's SSL certificate has expired",
    MC0000: 'Unrecognized error. Our team is analyzing the problem. Sorry',
    MC0001: 'Incorrect authorization data for the API',
    MC0002: 'Account is not active',
    MC0003: 'Incorrect data provided from the form',
    MC0004:
      'A critical error has occurred on the service side. Usually the problem is temporary',
    MC0005: 'The service is temporarily unavailable. Try to send lead again',
    MC0006: 'The service is temporarily unavailable. Try to send lead again',
    MC0007: 'Invalid interest identifier',
    MC0008:
      'API key is not active. You need to generate a new API key in the service and then enter it into the integration',
    MC0009: 'Incorrect e-mail address',
    MC0010: 'Incorrect additional field settings',
    MC0011: 'Contact exists',
    MC0012:
      'The contact has been added to many lists. The service does not allow you to add a contact to other lists',
    MC0013:
      'Resource not found. You may have entered the wrong configuration data',
    MC0014: 'Invalid list ID',
    MC0015: 'The e-mail has been deleted and cannot be added again',
    MC0016: 'Invalid API key',
    MC0017: 'Invalid status',
    MC0018:
      "Znak '-' nie został znaleziony w wkluczu API. Popraw klucz API w edytorze",
    MC0019: 'An invalid custom field type was passed',
    ML0000: 'Unrecognized error. Our team is analyzing the problem. Sorry',
    ML0001:
      'Invalid API key. You must enter the correct API key in integration',
    ML0002: 'Incorrect data provided from the form',
    ML0003:
      'A critical error has occurred on the service side. Usually the problem is temporary',
    ML0004: 'The service is temporarily unavailable. Try to send lead again',
    ML0005: 'The service is temporarily unavailable. Try to send lead again',
    ML0006: 'Incorrect e-mail address',
    ML0007:
      'The person with the provided e-mail address has unsubscribed from the list',
    ML0008: 'Subscriber type is bounced',
    ML0009:
      'The person with the e-mail address has not confirmed their e-mail address',
    ML0010:
      'The person with the provided email address has been detected as a spammer',
    ML0011: 'Invalid API key. Try to configurate integration once again',
    ML0012: 'The person with the e-mail address is temporarily blocked',
    ML0013:
      'Incorrect integration configuration in editor. Please try configure integration once again.',
    ML0014:
      'Data from form too large, MilerLite API returned 413 response code.',
    SA0000: 'Unrecognized error. Our team is analyzing the problem. Sorry',
    SA0001:
      'Invalid API key or User Id. You must enter the correct autorization data in Editor',
    SA0002:
      'Invalid contact list id or list does not exist. You must enter the correct list ID or add a list on the service side',
    SA0003: 'Invalid Email or email address not set.',
    SA0004:
      'A critical error has occurred on the service side. Usually the problem is temporary.',
    SA0005: 'The site is temporarily unavailable. Try to send lead again',
    SF0000: 'Unrecognized error. Our team is analyzing the problem. Sorry',
    SF0001:
      'Incorrect authorization data. You must enter valid authorization data in the integration',
    SF0002: 'Incorrect data provided from the form',
    SF0003:
      'A critical error has occurred on the service side. Usually the problem is temporary',
    SF0004: 'Contact already exists in the service',
    SF0005:
      'Data validation error. Please verify the validation settings in the integration',
    SF0006: 'The API account password has expired',
    SF0007: 'There is a link to a field that does not exist',
    SF0008: 'Contact is not unique',
    SF0009: 'The value for one of the form fields is too long',
    SF0010:
      "One of fields doesn't exist of could not be save. Check this field in SaleForce",
    SF0011: 'Invalid e-mail address',
    SF0012: 'Invalid RecordTypeId for this user',
    SF0013:
      'Required RecordTypeId column not found in Leads entity. Check configuration in Salesforce',
    PT0000: 'Unrecognized error. Our team is analyzing the problem. Sorry',
    PT0001: 'Bad request (HTTP code 400)',
    PT0002: 'Unprocessable Entity (HTTP code 422)',
    PT0003: 'Unauthorized (HTTP code 401)',
    PT0004: 'Forbidden (HTTP code 403)',
    PT0005: 'Not Found (HTTP code 404)',
    PT0006: 'Gone (HTTP code 410)',
    PT0007: 'Method not allowed (HTTP code 405)',
    PT0008: 'Unsupported media type (HTTP code 415)',
    PT0009: 'Conflict (HTTP code 409)',
    PT0010: 'Internal server error (HTTP code 500)',
    PT0011: 'Too many request (HTTP code 429)',
    PT0012: 'Request timeout (HTTP code 408)',
    PT0013: 'Service unavaliable (HTTP code 503)',
    PT0014: 'Bad gateway (HTTP code 502)',
    PT0015: 'Gateway timeout (HTTP code 504)',
    PT0016: 'Cloudflare origin timeout or down (HTTP code 521)',
    PT0017:
      "Couldn't resolve host. The given remote host was not resolved (CURL code 6)",
    PT0018: 'Failed to connect to host or proxy (CURL code 7)',
    PT0019:
      'Operation timeout. The specified time-out period was reached according to the conditions (CURL code 28)',
    PT0020:
      'A problem occurred somewhere in the SSL/TLS handshake (CURL code 35)',
    PT0021:
      'Nothing was returned from the server, getting nothing is considered an error (CURL code 52)',
    PT0022: 'OpenSSL SSL_read : SSL_ERROR_SYSCALL (CURL code 56)',
    PT0023:
      "CURLE_PEER_FAILED_VERIFICATION : The remote server's SSL certificate or SSH md5 fingerprint was deemed not OK (CURL code 60)",
    PT0024: 'Invalid URL',
    PT0025: '530 Not logged in (or Password Rejected)',
    PT0026: 'Origin Unreachable (HTTP code 523)',
    PT0027: 'Origin SSL Handshake Error (HTTP code 525)',
    PT0028: 'Payment Required (HTTP code 402)',
    PT0029: 'URL Redirection  (HTTP code 302)',
    PT0030: 'Error while processing content unencoding (CURL code 61)',
    PT0031: "I'm a teapot (HTTP code 418)",
    PT0032:
      'Transfer closed with outstanding read data remaining (CURL code 18)',
    PT0033: '508 Loop Detected',
    WH0000: 'Unrecognized error. Our team is analyzing the problem. Sorry',
    WH0001: 'Bad request (HTTP code 400)',
    WH0002: 'Unprocessable Entity (HTTP code 422)',
    WH0003: 'Unauthorized (HTTP code 401)',
    WH0004: 'Forbidden (HTTP code 403)',
    WH0005: 'Not Found (HTTP code 404)',
    WH0006: 'Gone (HTTP code 410)',
    WH0007: 'Method not allowed (HTTP code 405)',
    WH0008: 'Unsupported media type (HTTP code 415)',
    WH0009: 'Conflict (HTTP code 409)',
    WH0010: 'Internal server error (HTTP code 500)',
    WH0011: 'Too many request (HTTP code 429)',
    WH0012: 'Request timeout (HTTP code 408)',
    WH0013: 'Service unavaliable (HTTP code 503)',
    WH0014: 'Bad gateway (HTTP code 502)',
    WH0015: 'Gateway timeout (HTTP code 504)',
    WH0016: 'Cloudflare origin timeout or down (HTTP code 521)',
    WH0017: 'Payment Required (HTTP code 402)',
    WH0018: 'Invalid URL. Fix integration configuration in Editor',
    WH0019: 'URL Redirection  (HTTP code 302)',
    WH0020: 'Loop Detected (HTTP code 508)',
    WH0021: 'Insufficient Storage (HTTP code 507)',
    WH0022: 'Not Acceptable (HTTP code 406)',
    ZH0001: 'Incorrect authorization data for the API',
    ZH0002: 'User is not active',
    ZH0003: 'Incorrect data provided from the form',
    ZH0004:
      'A critical error has occurred on the service side. Usually the problem is temporary',
    ZH0005: 'The service is temporarily unavailable. Try to send lead again',
    ZH0006: 'The service is temporarily unavailable. Try to send lead again',
    ZH0007: 'Access denied',
    ZH0008: 'Incorrect API access token',
    ZH0009:
      'Missing mandatory field. You should fix integration form configuration.',
    ZH0010: 'Url malformed',
    ZH0011:
      'No new records can be created as you have reached your maximum data storage limit.',
    PD0001:
      'Incorrect authorization data. You must enter valid authorization data in the integration',
    PD0002: 'Invalid email address',
    PD0003:
      'A critical error has occurred on the service side. Usually the problem is temporary',
    PD0004: 'The service is temporarily unavailable. Try to send lead again',
    PD0005: 'The service is temporarily unavailable. Try to send lead again',
    PD0006: 'Resource not found',
    PD0007: 'Invalid campaign ID. Try to configurate integration once again',
    PD0008: 'Invalid API key. Try to configurate integration once again',
    PD0009: 'Stage not found or was deleted',
    PD0010: 'Undefined error in provided data',
    LS0001: 'Incorrect authorization data for the API',
    LS0002: 'Incorrect data provided from the form',
    LS0003:
      'A critical error has occurred on the service side. Usually the problem is temporary',
    LS0004: 'The service is temporarily unavailable. Try to send lead again',
    LS0005: 'The service is temporarily unavailable. Try to send lead again',
    LS0006: 'Invalid email address',
    LS0007:
      'Incorrect integration configuration in editor. Please try configure integration once again.',
    LS0008:
      'One of the fields has not been completed, set this fields as required in the form settings',
    LS0009:
      'Contact exists, but has empty email. Impossible to update contact.',
    DR0000: 'Unrecognized error. Our team is analyzing the problem. Sorry',
    DR0001: 'Incorrect API authorization data or account does not exist',
    DR0002: 'Incorrect data provided from the form',
    DR0003:
      'A critical error has occurred on the service side. Usually the problem is temporary',
    DR0004: 'The site is temporarily unavailable. Try to send lead again',
    DR0005: 'The site is temporarily unavailable. Try to send lead again',
    DR0007:
      'Incorrect integration configuration in editor. Please try configure integration once again.',
    DR0008: 'A numeric value is out of range.',
    DR0009: 'The attribute is required.',
    DR0010: 'The length of the attribute is out of bounds.',
    DR0011: 'The attribute must be unique.',
    DR0012: 'The attribute must be a valid email address.',
    DR0013: 'The attribute must be a valid URL.',
    DR0014: 'The attribute must be a valid domain name.',
    DR0015: 'The attribute must be a valid time in ISO-8601 format.',
    DR0016:
      'The attribute must be a valid comma-separated list of email addresses.',
    DR0017: 'The attribute must be a valid days of the week mask.',
    DR0018: 'A resource has been disabled or deleted.',
    DR0019: 'A resource identifier or object is not formatted correctly.',
    ZP0000: 'Unrecognized error. Our team is analyzing the problem. Sorry',
    ZP0001: 'Invalid configuration. Try to configure integration once again',
    ZP0002:
      'Invalid Zap configuration. Go to your Zap and ensure that all necessary fields exist.',
    ZP0003: 'Zapier Server error. Please try send lead once again.',
    ZO0001:
      'Invalid configuration of Zapier URL. Try to configure integration once again in editor',
    NE0000: 'Unrecognized error. Our team is analyzing the problem. Sorry',
    NE0001: 'Invalid phone number',
    NE0002:
      'A critical error has occurred on the service side. Usually the problem is temporary.',
    NE0003: 'The site is temporarily unavailable. Try to send lead again',
    NE0004: 'The site is temporarily unavailable. Try to send lead again',
    NE0005: 'Invalid security key',
    YL0000: 'Unrecognized error. Our team is analyzing the problem. Sorry',
    YL0001:
      'A critical error has occurred on the service side. Usually the problem is temporary.',
    YL0002: 'The site is temporarily unavailable. Try to send lead again',
    YL0003: 'The site is temporarily unavailable. Try to send lead again',
    ZM0000: 'Unrecognized error. Our team is analyzing the problem. Sorry',
    ZM0001:
      'A critical error has occurred on the service side. Usually the problem is temporary.',
    ZM0002: 'The site is temporarily unavailable. Try to send lead again',
    ZM0003: 'The site is temporarily unavailable. Try to send lead again',
    ZM0004: 'This webinar is over, you can no longer register for this webinar',
    ZM0005: 'Token not found. Did you uninstall Landingi app on Zoom?',
    ZM0006: 'Registration has not been enabled for this webinar',
    ZM0007:
      'You have exceeded the daily rate limit of add this registrant to webinar',
    ZM0008: 'Email field must not be empty',
    ZM0009: 'First name field is empty, field must be required',
    ZM0010: 'Last name field is empty, field must be required',
    ZS0000: 'Unrecognized error. Our team is analyzing the problem. Sorry',
    ZS0001:
      'A critical error has occurred on the service side. Usually the problem is temporary.',
    ZS0002: 'The site is temporarily unavailable. Try to send lead again',
    ZS0003: 'The site is temporarily unavailable. Try to send lead again',
    ZS0004: 'Incorrect data provided from the form',
    ZS0005:
      'Invalid authorization token. You must enter the correct token in the integration',
    LW0000: 'Unrecognized error. Our team is analyzing the problem. Sorry',
    LW0001:
      'A critical error has occurred on the service side. Usually the problem is temporary.',
    LW0002: 'The site is temporarily unavailable. Try to send lead again',
    LW0003: 'The site is temporarily unavailable. Try to send lead again',
    LW0004: 'Incorrect data provided from the form',
    LW0005: 'The webinar was not found',
    LW0006:
      'The Token was expired and deleted. Try logging in to the editor again',
    HS2000: 'Unrecognized error. Our team is analyzing the problem. Sorry',
    HS2001:
      'Invalid authorization token. You must enter the correct token in integration',
    HS2002: 'The account has been temporarily suspended',
    HS2003: 'Incorrect data provided from the form',
    HS2004:
      'A critical error has occurred on the service side. Usually the problem is temporary',
    HS2005: 'The service is temporarily unavailable. Try to send lead again',
    HS2006: 'The service is temporarily unavailable. Try to send lead again',
    HS2007: 'Incorrect e-mail address',
    HS2008: 'Invalid value for a numeric type field in HubSpot',
    CR0000: 'Unrecognized error. Our team is analyzing the problem. Sorry',
    CR0001:
      'A critical error has occurred on the service side. Usually the problem is temporary.',
    CR0002: 'The site is temporarily unavailable. Try to send lead again',
    CR0003: 'The site is temporarily unavailable. Try to send lead again',
    CR0004:
      'Creatio returned 400 (Bad Request). Please check the integration configuration in the editor',
    CR0005: 'Missing form value for provided date format',
    TC0000: 'Unrecognized error. Our team is analyzing the problem. Sorry',
    TC0001:
      'A critical error has occurred on the service side. Usually the problem is temporary.',
    TC0002: 'The site is temporarily unavailable. Try to send lead again',
    TC0003: 'The site is temporarily unavailable. Try to send lead again',
    TC0004: 'Thrive Coach return 404 (Not Found)',
    TC0005:
      'ApiToken not Found. Please try to configure integration once again.',
    TC0006:
      'Location not Found. Please try to configure integration once again.'
  },
  pt: {
    '0000':
      'Erro não reconhecido. Nossa equipe está analisando o problema. Desculpa',
    AC0000:
      'Erro não reconhecido. Nossa equipe está analisando o problema. Desculpa',
    AC0001: 'Nenhum SSL para o domínio indicado',
    AC0002:
      'Chave de API inválida. Você deve inserir a chave de API correta na integração',
    AC0003:
      'Endereço de destino da API inválido. Você deve inserir o endereço de destino correto para a API na integração',
    AC0004:
      'ID de lista de contatos inválido ou a lista não existe. Você deve inserir o ID de lista correto ou adicionar uma lista no lado do serviço',
    AC0005: 'Dados incorretos fornecidos no formulário',
    AC0006: 'Conta não paga no serviço',
    AC0007:
      'Ocorreu um erro crítico no lado do serviço. Geralmente o problema é temporário',
    AC0008:
      'O site está temporariamente indisponível. Tente enviar o lead novamente',
    AC0009:
      'O site está temporariamente indisponível. Tente enviar o lead novamente',
    AC0010: 'O endereço de e-mail já existe em serviço',
    AC0011: 'Tag não encontrada',
    AC0012: 'Havia uma tag duplicada no contato',
    AC0013: 'Endereço de e-mail incorreto',
    AC0014: 'Nenhum contato encontrado para associar à lista',
    AC0015: 'O endereço de e-mail já existe em serviço',
    AC0016:
      'Valor inválido para tag de contato. Talvez o contato já tenha esta tag',
    AC0017: 'Conflito nos dados',
    AC0018:
      'Erro de servidor. Transferência fechada com dados de leitura pendentes restantes',
    AC0019:
      'Nada foi retornado do servidor, receber nada é considerado um erro (código CURL 52)',
    AC0020: 'Assinante não encontrado',
    AC0021:
      'Erro de retorno ActiveCampaign 404 (não encontrado) com mensagem vazia. Verifique a configuração de integração no editor.',
    AC0022:
      'Erro de retorno ActiveCampaign 405 com mensagem vazia. Verifique a configuração de integração no editor.',
    AW0000:
      'Erro não reconhecido. Nossa equipe está analisando o problema. Desculpa',
    AW0001: 'Dados de autorização de API incorretos',
    AW0002: 'A conta foi temporariamente suspensa',
    AW0003: 'Dados incorretos fornecidos no formulário',
    AW0004:
      'Ocorreu um erro crítico no lado do serviço. Geralmente o problema é temporário',
    AW0005:
      'O site está temporariamente indisponível. Tente enviar o lead novamente',
    AW0006:
      'O site está temporariamente indisponível. Tente enviar o lead novamente',
    AW0007: 'O assinante existe no site',
    AW0008: 'O endereço de e-mail está bloqueado',
    AW0009: 'Endereço de e-mail incorreto',
    AW0010:
      'Nada foi retornado do servidor, receber nada é considerado um erro (código CURL 52)',
    AW0011:
      'A lista de e-mail não foi encontrada. Corrija a configuração de integração no editor',
    CA0000:
      'Erro não reconhecido. Nossa equipe está analisando o problema. Desculpa',
    CA0001:
      'Chave de API inválida. Você deve inserir a chave de API correta na integração',
    CA0002:
      'ID de lista de contatos inválido ou lista não existe. Você deve inserir o ID de lista correto ou adicionar uma lista no lado do serviço',
    CA0003: 'Dados incorretos fornecidos no formulário',
    CA0004:
      'Ocorreu um erro crítico no lado do serviço. Geralmente o problema é temporário.',
    CA0005:
      'O site está temporariamente indisponível. Tente enviar o lead novamente',
    CA0006:
      'O site está temporariamente indisponível. Tente enviar o lead novamente',
    CA0007: 'Número de telefone inválido',
    CM0000:
      'Erro não reconhecido. Nossa equipe está analisando o problema. Desculpa',
    CM0001:
      'Chave de API inválida. Você deve inserir a chave de API correta na integração',
    CM0002:
      'ID de cliente inválido. Você deve inserir o ID de cliente correto para API na integração',
    CM0003:
      'ID de lista de contatos inválido ou lista não existe. Você deve inserir o ID de lista correto ou adicionar uma lista no lado do serviço',
    CM0004: 'Dados incorretos fornecidos no formulário',
    CM0005:
      'Ocorreu um erro crítico no lado do serviço. Geralmente o problema é temporário.',
    CM0006:
      'O site está temporariamente indisponível. Tente enviar o lead novamente',
    CM0007:
      'O site está temporariamente indisponível. Tente enviar o lead novamente',
    CM0008: 'O endereço de e-mail existe na lista não confirmada',
    CM0009: 'O endereço de e-mail existe na lista de supressão',
    CM00010: 'O endereço de e-mail existe na lista de não inscritos',
    CK0000:
      'Erro não reconhecido. Nossa equipe está analisando o problema. Desculpa',
    CK0001: 'Dados de autorização de API incorretos',
    CK0002: 'Dados incorretos fornecidos no formulário',
    CK0003:
      'Ocorreu um erro crítico no lado do serviço. Geralmente o problema é temporário',
    CK0004:
      'O site está temporariamente indisponível. Tente enviar o lead novamente',
    CK0005:
      'O site está temporariamente indisponível. Tente enviar o lead novamente',
    CK0006: 'Endereço de e-mail incorreto',
    CK0007:
      'Configuração de integração incorreta no editor. Por favor, tente configurar a integração mais uma vez.',
    CK0008: 'O parâmetro do primeiro nome é inválido',
    CK0009: 'O parâmetro de e-mail é inválido',
    FM0000:
      'Erro não reconhecido. Nossa equipe está analisando o problema. Desculpa',
    FM0001: 'Dados de autorização de API incorretos',
    FM0002: 'Dados incorretos fornecidos no formulário',
    FM0003:
      'Ocorreu um erro crítico no lado do serviço. Geralmente o problema é temporário',
    FM0004:
      'O serviço está temporariamente indisponível. Tente enviar o lead novamente',
    FM0005:
      'O serviço está temporariamente indisponível. Tente enviar o lead novamente',
    FM0006:
      'ID de lista de contatos inválido ou a lista não existe. Você deve inserir o ID de lista correto ou adicionar uma lista no lado do serviço',
    FM0007: 'Endereço de email invalido',
    FM0008: 'problema de conexão SSL',
    FM0009: 'O valor do campo personalizado inválido ou o campo não existe.',
    GR0000:
      'Erro não reconhecido. Nossa equipe está analisando o problema. Desculpa',
    GR0001: 'Dados de autorização incorretos para a API',
    GR0002: 'Formato de campo personalizado inválido',
    GR0003: 'Dados incorretos fornecidos no formulário',
    GR0004:
      'Ocorreu um erro crítico no lado do serviço. Geralmente o problema é temporário',
    GR0005:
      'O serviço está temporariamente indisponível. Tente enviar o lead novamente',
    GR0006:
      'O serviço está temporariamente indisponível. Tente enviar o lead novamente',
    GR0007: 'O endereço de e-mail já existe em serviço',
    GR0008: 'O e-mail fornecido está na lista negra do serviço',
    GR0009: 'O e-mail fornecido já foi removido do serviço',
    GR0010: 'Endereço de e-mail incorreto',
    GR0011: 'A campanha errada ou a campanha especificada não existe',
    GR0012: 'O contato está esperando para ser adicionado no lado do serviço',
    GR0013: 'O contato foi rejeitado anteriormente',
    GR0014: 'Chave de API inválida. Tente configurar a integração mais uma vez',
    GR0015:
      'Ponto de extremidade inválido. Tente configurar a integração mais uma vez',
    GR0016:
      'Domínio fornecido não encontrado. Tente configurar a integração mais uma vez',
    GR0017:
      'Não é possível adicionar o contato que está bloqueado no GetResponse.',
    GS0000:
      'Erro não reconhecido. Nossa equipe está analisando o problema. Desculpa',
    GS0001:
      'Ocorreu um erro crítico no lado do serviço. Geralmente o problema é temporário',
    GS0002:
      'O serviço está temporariamente indisponível. Tente enviar o lead novamente',
    GS0003:
      'O serviço está temporariamente indisponível. Tente enviar o lead novamente',
    GS0004: 'Autorização inválida. Tente configurar a integração mais uma vez',
    GS0005: 'Configuração inválida. Tente configurar a integração mais uma vez',
    GS0006:
      'Intervalo de folhas excedido. Aumente o número de linhas na planilha vinculada',
    GS0007: 'O nome da planilha está incorreto. Não use caracteres especiais',
    GS0008: 'A conta foi banida pela integração GS',
    HS0000:
      'Erro não reconhecido. Nossa equipe está analisando o problema. Desculpa',
    HS0001:
      'Chave de API inválida. Você deve inserir a chave de API correta na integração',
    HS0002: 'A conta foi temporariamente suspensa',
    HS0003: 'Dados incorretos fornecidos no formulário',
    HS0004:
      'Ocorreu um erro crítico no lado do serviço. Geralmente o problema é temporário',
    HS0005:
      'O serviço está temporariamente indisponível. Tente enviar o lead novamente',
    HS0006:
      'O serviço está temporariamente indisponível. Tente enviar o lead novamente',
    HS0007: 'Endereço de e-mail incorreto',
    HS0008: 'Valor inválido para um campo de tipo numérico no HubSpot',
    HS0009:
      'Esta integração não está mais ativa. Lançamos uma integração HubSpot OAuth atualizada. Se você deseja enviar os leads para sua conta da HubSpot, configure a nova integração.',
    LB0000:
      'Erro não reconhecido. Nossa equipe está analisando o problema. Desculpa',
    LB0001:
      'Chave de API inválida. Você deve inserir a chave de API correta na integração',
    LB0002: 'Dados incorretos fornecidos no formulário',
    LB0003:
      'Ocorreu um erro crítico no lado do serviço. Geralmente o problema é temporário',
    LB0004:
      'O serviço está temporariamente indisponível. Tente enviar o lead novamente',
    LB0005:
      'O serviço está temporariamente indisponível. Tente enviar o lead novamente',
    LB0006: 'A campanha não existe',
    LB0007: 'Nenhum SSL para o domínio indicado',
    LB0008: 'O certificado SSL do domínio expirou',
    MC0000:
      'Erro não reconhecido. Nossa equipe está analisando o problema. Desculpa',
    MC0001: 'Dados de autorização incorretos para a API',
    MC0002: 'A conta não está ativa',
    MC0003: 'Dados incorretos fornecidos no formulário',
    MC0004:
      'Ocorreu um erro crítico no lado do serviço. Geralmente o problema é temporário',
    MC0005:
      'O serviço está temporariamente indisponível. Tente enviar o lead novamente',
    MC0006:
      'O serviço está temporariamente indisponível. Tente enviar o lead novamente',
    MC0007: 'Identificador de interesse inválido',
    MC0008:
      'A chave de API não está ativa. Você precisa gerar uma nova chave de API no serviço e inseri-la na integração',
    MC0009: 'Endereço de e-mail incorreto',
    MC0010: 'Configurações de campo adicionais incorretas',
    MC0011: 'O contato existe',
    MC0012:
      'O contato foi adicionado a muitas listas. O serviço não permite adicionar um contato a outras listas',
    MC0013:
      'Recurso não encontrado. Você pode ter inserido os dados de configuração errados',
    MC0014: 'ID de lista inválido',
    MC0015: 'O e-mail foi excluído e não pode ser adicionado novamente',
    MC0016: 'Chave de API inválida',
    MC0017: 'Status inválido',
    MC0018: "Sinal '-' não encontrado, corrija a CHAVE da API no editor",
    MC0019: 'Foi transmitido um tipo de campo personalizado inválido',
    ML0000:
      'Erro não reconhecido. Nossa equipe está analisando o problema. Desculpa',
    ML0001:
      'Chave de API inválida. Você deve inserir a chave de API correta na integração',
    ML0002: 'Dados incorretos fornecidos no formulário',
    ML0003:
      'Ocorreu um erro crítico no lado do serviço. Geralmente o problema é temporário',
    ML0004:
      'O serviço está temporariamente indisponível. Tente enviar o lead novamente',
    ML0005:
      'O serviço está temporariamente indisponível. Tente enviar o lead novamente',
    ML0006: 'Endereço de e-mail incorreto',
    ML0007:
      'A pessoa com o endereço de e-mail fornecido cancelou a inscrição na lista',
    ML0008: 'O tipo de assinante é rejeitado',
    ML0009:
      'A pessoa com o endereço de e-mail não confirmou seu endereço de e-mail',
    ML0010:
      'A pessoa com o endereço de e-mail fornecido foi detectada como spammer',
    ML0011: 'Chave de API inválida. Tente configurar a integração mais uma vez',
    ML0012: 'A pessoa com o endereço de e-mail está temporariamente bloqueada',
    ML0013:
      'Configuração de integração incorreta no editor. Por favor, tente configurar a integração mais uma vez.',
    ML0014:
      'Dados do formulário muito grandes, a API do MilerLite retornou o código de resposta 413.',
    SA0000:
      'Erro não reconhecido. Nossa equipe está analisando o problema. desculpa',
    SA0001:
      'Chave de API ou ID de usuário inválido. Você deve inserir os dados de autorização corretos no Editor',
    SA0002:
      'ID de lista de contatos inválido ou lista não existe. Você deve inserir o ID de lista correto ou adicionar uma lista no lado do serviço',
    SA0003: 'E-mail inválido ou endereço de e-mail não definido.',
    SA0004:
      'Ocorreu um erro crítico no lado do serviço. Geralmente o problema é temporário.',
    SA0005:
      'O site está temporariamente indisponível. Tente enviar o lead novamente',
    SF0000:
      'Erro não reconhecido. Nossa equipe está analisando o problema. Desculpa',
    SF0001:
      'Dados de autorização incorretos. Você deve inserir dados de autorização válidos na integração',
    SF0002: 'Dados incorretos fornecidos no formulário',
    SF0003:
      'Ocorreu um erro crítico no lado do serviço. Geralmente o problema é temporário',
    SF0004: 'O contato já existe no serviço',
    SF0005:
      'Erro de validação de dados. Verifique as configurações de validação na integração',
    SF0006: 'A senha da conta da API expirouA senha da conta da API expirou',
    SF0007: 'Existe um link para um campo que não existe',
    SF0008: 'O contato não é único',
    SF0009: 'O valor de um dos campos do formulário é muito longo',
    SF0010: 'Um dos campos não existe',
    SF0011: 'Endereço de email invalido',
    SF0012: 'RecordTypeId inválido para este usuário',
    SF0013:
      'Coluna RecordTypeId necessária não encontrada na entidade Leads, verifique a configuração no Salesforce',
    PT0000:
      'Erro não reconhecido. Nossa equipe está analisando o problema. Desculpa',
    PT0001: 'Solicitação inválida (código HTTP 400)',
    PT0002: 'Entidade não processável (código HTTP 422)',
    PT0003: 'Não autorizado (código HTTP 401)',
    PT0004: 'Proibido (código HTTP 403)',
    PT0005: 'Não encontrado (código HTTP 404)',
    PT0006: 'Desaparecido (código HTTP 410)',
    PT0007: 'Método não permitido (código HTTP 405)',
    PT0008: 'Tipo de mídia não compatível (código HTTP 415)',
    PT0009: 'Conflito (código HTTP 409)',
    PT0010: 'Erro interno do servidor (código HTTP 500)',
    PT0011: 'Muitos pedidos (código HTTP 429)',
    PT0012: 'Tempo limite da solicitação (código HTTP 408)',
    PT0013: 'Serviço indisponível (código HTTP 503)',
    PT0014: 'Gateway inválido (código HTTP 502)',
    PT0015: 'Tempo limite do gateway (código HTTP 504)',
    PT0016: 'Tempo limite de origem ou para baixo (HTTP código 521)',
    PT0017:
      'Não foi possível resolver o host. O host remoto fornecido não foi resolvido (código CURL 6)',
    PT0018: 'Falha ao conectar ao host ou proxy (código CURL 7)',
    PT0019:
      'Tempo limite de operação. O período de tempo limite especificado foi atingido de acordo com as condições (código CURL 28)',
    PT0020:
      'Ocorreu um problema em algum lugar no handshake SSL%/TLS (código CURL 35)',
    PT0021:
      'Nada foi retornado do servidor, receber nada é considerado um erro (código CURL 52)',
    PT0022: 'OpenSSL SSL_read :  SSL_ERROR_SYSCALL (código CURL 56)',
    PT0023:
      'CURLE_PEER_FAILED_VERIFICATION :  O certificado SSL do servidor remoto ou impressão digital SSH md5 foi considerado incorreto (código CURL 60)',
    PT0024: 'URL inválida',
    PT0025: '530 Não logado (ou senha rejeitada)',
    PT0026: 'Origem inacessível (código HTTP 523)',
    PT0027: 'Erro de handshake SSL de origem (código HTTP 525)',
    PT0028: 'Pagamento obrigatório (código HTTP 402)',
    PT0029: 'Redirecionamento de URL (código HTTP 302)',
    PT0030: 'Erro ao processar a descodificação do conteúdo (código CURL 61)',
    PT0031: "I'm a teapot (HTTP code 418)",
    PT0032:
      'Transfer closed with outstanding read data remaining (CURL code 18)',
    PT0033: '508 Loop Detected',
    WH0000:
      'Erro não reconhecido. Nossa equipe está analisando o problema. Desculpa',
    WH0001: 'Solicitação inválida (código HTTP 400)',
    WH0002: 'Entidade não processável (código HTTP 422)',
    WH0003: 'Não autorizado (código HTTP 401)',
    WH0004: 'Proibido (código HTTP 403)',
    WH0005: 'Não encontrado (código HTTP 404)',
    WH0006: 'Desaparecido (código HTTP 410)',
    WH0007: 'Método não permitido (código HTTP 405)',
    WH0008: 'Tipo de mídia não compatível (código HTTP 415)',
    WH0009: 'Conflito (código HTTP 409)',
    WH0010: 'Erro interno do servidor (código HTTP 500)',
    WH0011: 'Muitos pedidos (código HTTP 429)',
    WH0012: 'Tempo limite da solicitação (código HTTP 408)',
    WH0013: 'Serviço indisponível (código HTTP 503)',
    WH0014: 'Gateway inválido (código HTTP 502)',
    WH0015: 'Tempo limite do gateway (código HTTP 504)',
    WH0016: 'Tempo limite de origem do Cloudflare reduzido (código HTTP 521)',
    WH0017: 'Pagamento obrigatório (código HTTP 402)',
    WH0018: 'URL inválida. Corrigir configuração de integração no Editor',
    WH0019: 'Redirecionamento de URL (código HTTP 302)',
    WH0020: 'Loop detectado (código HTTP 508)',
    WH0021: 'Armazenamento insuficiente (código HTTP 507)',
    WH0022: 'Não aceitável (código HTTP 406)',
    ZH0001: 'Dados de autorização incorretos para a API',
    ZH0002: 'O usuário não está ativo',
    ZH0003: 'Dados incorretos fornecidos no formulário',
    ZH0004:
      'Ocorreu um erro crítico no lado do serviço. Geralmente o problema é temporário',
    ZH0005:
      'O serviço está temporariamente indisponível. Tente enviar o lead novamente',
    ZH0006:
      'O serviço está temporariamente indisponível. Tente enviar o lead novamente',
    ZH0007: 'Acesso negado',
    ZH0008: 'Token de acesso à API incorreto',
    ZH0009:
      'Campo obrigatório ausente. Você deve corrigir a configuração de integração do formulário.',
    ZH0010: 'URL mal formado',
    ZH0011:
      'Nenhum novo registro pode ser criado porque você atingiu seu limite máximo de armazenamento de dados.',
    PD0001:
      'Dados de autorização incorretos. Você deve inserir dados de autorização válidos na integraçãoa',
    PD0002: 'Endereço de email invalido',
    PD0003:
      'Ocorreu um erro crítico no lado do serviço. Geralmente o problema é temporário',
    PD0004:
      'O serviço está temporariamente indisponível. Tente enviar o lead novamente',
    PD0005:
      'O serviço está temporariamente indisponível. Tente enviar o lead novamente',
    PD0006: 'Recurso não encontrado',
    PD0007:
      'ID de campanha inválido. Tente configurar a integração mais uma vez',
    PD0008: 'Chave de API inválida. Tente configurar a integração mais uma vez',
    PD0009: 'Palco não encontrado ou deletado',
    PD0010: 'Erro indefinido nos dados fornecidos',
    LS0001:
      'Chave de API inválida ou permissões insuficientes. Você deve inserir a chave de API correta na integração ou definir as permissões corretas para a conta no Livespace.',
    LS0002: 'Dados incorretos fornecidos no formulário',
    LS0003:
      'Ocorreu um erro crítico no lado do serviço. Geralmente o problema é temporário',
    LS0004:
      'O serviço está temporariamente indisponível. Tente enviar o lead novamente',
    LS0005:
      'O serviço está temporariamente indisponível. Tente enviar o lead novamente',
    LS0006: 'Endereço de email invalido',
    LS0007:
      'Configuração de integração incorreta no editor. Por favor, tente configurar a integração mais uma vez.',
    LS0008:
      'Um dos campos não foi preenchido, defina esses campos conforme necessário nas configurações do formulário',
    LS0009:
      'O contato existe, mas o e-mail esta vazio, impossível atualizar o contato',
    DR0001: 'Dados de autorizacao de API incorretos ou conta inexistente',
    DR0002: 'Dados incorretos fornecidos no formulario',
    DR0003:
      'Ocorreu um erro critico no lado do servico. Geralmente o problema e temporario',
    DR0004:
      'O site esta temporariamente indisponivel. Tente enviar o lead novamente',
    DR0005:
      'O site esta temporariamente indisponivel. Tente enviar o lead novamente',
    DR0007:
      'Configuracao de integracao incorreta no editor. Por favor, tente configurar a integracao mais uma vez.',
    DR0008: 'Um valor numerico esta fora do intervalo.',
    DR0009: 'O atributo e obrigatorio.',
    DR0010: 'O comprimento do atributo esta fora dos limites.',
    DR0011: 'O atributo deve ser exclusivo.',
    DR0012: 'O atributo deve ser um endereco de e-mail valido.',
    DR0013: 'O atributo deve ser um URL valido.',
    DR0014: 'O atributo deve ser um nome de dominio valido.',
    DR0015: 'O atributo deve ser uma hora valida no formato ISO-8601.',
    DR0016:
      'O atributo deve ser uma lista valida de enderecos de e-mail separados por virgulas.',
    DR0017: 'O atributo deve ser uma mascara valida de dias da semana.',
    DR0018: 'Um recurso foi desativado ou excluido.',
    DR0019:
      'Um identificador de recurso ou objeto nao esta formatado corretamente.',
    ZP0000:
      'Erro não reconhecido. Nossa equipe está analisando o problema. Desculpa',
    ZP0001: 'Configuração inválida. Tente configurar a integração mais uma vez',
    ZP0002:
      'Configuração de Zap inválida. Acesse seu Zap e verifique se todos os campos necessários existem.',
    ZP0003: 'Erro do servidor Zapier. Tente enviar o lead novamente.',
    ZO0001:
      'Configuração inválida da URL do Zapier. Tente configurar a integração mais uma vez no editor',
    NE0000:
      'Erro não reconhecido. Nossa equipe está analisando o problema. Desculpa',
    NE0001: 'Número de telefone inválido',
    NE0002:
      'Ocorreu um erro crítico no lado do serviço. Geralmente o problema é temporário.',
    NE0003:
      'O site está temporariamente indisponível. Tente enviar o lead novamente',
    NE0004:
      'O site está temporariamente indisponível. Tente enviar o lead novamente',
    NE0005: 'Chave de segurança inválida',
    YL0000:
      'Erro não reconhecido. Nossa equipe está analisando o problema. Desculpa',
    YL0001:
      'Ocorreu um erro crítico no lado do serviço. Geralmente o problema é temporário.',
    YL0002:
      'O site está temporariamente indisponível. Tente enviar o lead novamente',
    YL0003:
      'O site está temporariamente indisponível. Tente enviar o lead novamente',
    ZM0000:
      'Erro não reconhecido. Nossa equipe está analisando o problema. Desculpa',
    ZM0001:
      'Ocorreu um erro crítico no lado do serviço. Geralmente o problema é temporário.',
    ZM0002:
      'O site está temporariamente indisponível. Tente enviar o lead novamente',
    ZM0003:
      'O site está temporariamente indisponível. Tente enviar o lead novamente',
    ZM0004:
      'Este webinar acabou, você não pode mais se registrar para este webinar',
    ZM0005:
      'Token não encontrado. Você desinstalou o aplicativo Landingi no Zoom?',
    ZM0006: 'O registro não foi ativado para este webinar',
    ZM0007:
      'Você excedeu o limite de taxa diária para adicionar este registro ao webinar',
    ZM0008: 'O campo de e-mail está vazio, o campo deve ser obrigatório',
    ZM0009: 'O campo do primeiro nome está vazio, o campo deve ser obrigatório',
    ZM0010: 'O campo sobrenome está vazio, o campo deve ser obrigatório',
    ZS0000:
      'Erro não reconhecido. Nossa equipe está analisando o problema. Desculpa',
    ZS0001:
      'Ocorreu um erro crítico no lado do serviço. Geralmente o problema é temporário.',
    ZS0002:
      'O site está temporariamente indisponível. Tente enviar o lead novamente',
    ZS0003:
      'O site está temporariamente indisponível. Tente enviar o lead novamente',
    ZS0004: 'Dados incorretos fornecidos no formulário',
    ZS0005:
      'Token de autorização inválido. Você deve inserir o token correto na integração',
    LW0000:
      'Erro não reconhecido. Nossa equipe está analisando o problema. Desculpa',
    LW0001:
      'Ocorreu um erro crítico no lado do serviço. Geralmente o problema é temporário.',
    LW0002:
      'O site está temporariamente indisponível. Tente enviar o lead novamente',
    LW0003:
      'O site está temporariamente indisponível. Tente enviar o lead novamente',
    LW0004: 'Dados incorretos fornecidos no formulário',
    LW0005: 'O webinar não foi encontrado',
    LW0006:
      'O token expirou e foi excluído. Tente fazer login no editor novamente',
    HS2000:
      'Erro não reconhecido. Nossa equipe está analisando o problema. Desculpa',
    HS2001:
      'Token de autorização inválido. Você deve inserir o token correto na integração',
    HS2002: 'A conta foi temporariamente suspensa',
    HS2003: 'Dados incorretos fornecidos no formulário',
    HS2004:
      'Ocorreu um erro crítico no lado do serviço. Geralmente o problema é temporário',
    HS2005:
      'O serviço está temporariamente indisponível. Tente enviar o lead novamente',
    HS2006:
      'O serviço está temporariamente indisponível. Tente enviar o lead novamente',
    HS2007: 'Endereço de e-mail incorreto',
    HS2008: 'Valor inválido para um campo de tipo numérico no HubSpot',
    CR0000:
      'Erro não reconhecido. Nossa equipe está analisando o problema. Desculpa',
    CR0001:
      'Ocorreu um erro crítico no lado do serviço. Geralmente o problema é temporário.',
    CR0002:
      'O site está temporariamente indisponível. Tente enviar o lead novamente',
    CR0004:
      'Creatio retorna 400 (Solicitação inválida). Verifique a configuração de integração no editor',
    CR0005: 'Falta o valor do formulário para o formato de data fornecido',
    TC0000:
      'Erro não reconhecido. Nossa equipe está analisando o problema. Desculpa',
    TC0001:
      'Ocorreu um erro crítico no lado do serviço. Geralmente o problema é temporário.',
    TC0002:
      'O site está temporariamente indisponível. Tente enviar o lead novamente',
    TC0003:
      'O site está temporariamente indisponível. Tente enviar o lead novamente',
    TC0004: 'Thrive Coach retorna 404 (não encontrado)',
    TC0005:
      'ApiToken não encontrado. Por favor, tente configurar a integração mais uma vez.',
    TC0006:
      'Localizações não encontrado. Por favor, tente configurar a integração mais uma vez.'
  }
} as const
